<template>
  <div>
    <base-screen>
      <el-form :inline="true" :model="param" label-position="left"
               ref="screenForm"
               @keydown.native.enter="searchSubmit"
               @submit.native.prevent>
        <el-form-item label="服务名称：">
          <el-input v-model="param.serviceName" placeholder="服务名称"></el-input>
        </el-form-item>
        <el-form-item label="适用范围：">
          <el-input v-model="param.useRange" placeholder="适用范围"></el-input>
        </el-form-item>
        <el-form-item label="是否上架：">
          <el-select v-model="param.onFlag" placeholder="请选择">
            <el-option label="" value=""></el-option>
            <el-option label="上架" value="1">上架</el-option>
            <el-option label="下架" value="0">下架</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否接单：">
          <el-select v-model="param.validFlag" placeholder="请选择">
            <el-option label="" value=""></el-option>
            <el-option label="开启" value="1">开启</el-option>
            <el-option label="关闭" value="0">关闭</el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="searchSubmit">查询</el-button>
          <el-button type="text" @click="resetSearchSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <div class="tr">
        <el-button type="primary" @click="$router.push({name:'SeveForm',params:{serviceTypeId:serviceTypeId}})" v-pms="'add'">添加服务</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableDataLoading"
        border
        style="width: 100%">
        <el-table-column
          fixed
          prop="seqNum"
          label="排序号"
          width="70">
        </el-table-column>
        <el-table-column
          prop="serviceName"
          label="服务名称"
          width="200">
          <template slot-scope="{row}">
            <el-button type="text" class="link" @click="$router.push({path: `${$route.path}/detail/${row.serviceId}`})" v-pms="'look'">{{row.serviceName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="价格"
          width="60">
        </el-table-column>
        <el-table-column
          prop="useRange"
          label="适用范围"
          width="250">
        </el-table-column>
        <el-table-column
          prop="onFlag"
          label="是否上架"
          width="80">
          <el-switch slot-scope="{row}" :value="row.onFlag" @change="toggleOn(arguments[0], row)" v-pms="'tog'"></el-switch>
        </el-table-column>
        <el-table-column
          prop="onFlag"
          label="是否接单"
          width="80">
          <el-switch slot-scope="{row}" :value="row.validFlag" @change="toggleOpen(arguments[0], row)" v-pms="'open'"></el-switch>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button @click="$router.push({path: `${$route.path}/update/${scope.row.serviceId}`})" type="text"
                       size="small" v-pms="'edit'">编辑
            </el-button>
            <el-button @click="deleteServe(scope.$index)" type="text" size="small" v-pms="'delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageNum"
      :page-sizes="[10, 15, 20]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total">
    </el-pagination>
  </div>
</template>

<script>
import {serve} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'
export default {
  name: 'ServeTypeManage',
  props: {
    serviceTypeId: {
      type: String,
      default: ''
    }
  },
  watch: {
    serviceTypeId (value) {
      this.param.serviceTypeId = value
      this.getTableData()
    }
  },
  data () {
    return {
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      param: {
        orgCode: getSession(ORG_CODE),
        serviceName: '',
        serviceTypeId: '',
        onFlag: '',
        validFlag: '',
        useRange: ''
      },
      tableDataLoading: false
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await serve.pageServe({
        param: this.param,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    searchSubmit () {
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.param.serviceName = ''
      this.param.useRange = ''
      this.param.onFlag = ''
      this.param.validFlag = ''
      this.getTableData()
    },
    async toggleOn (value, row) {
      let {code, msg} = await serve.toggleServeValid({serviceId: row.serviceId})
      if (code === 0) {
        row.onFlag = value
      } else {
        this.$message({
          type: 'error',
          message: msg
        })
      }
    },
    async toggleOpen (value, row) {
      let {code, msg} = await serve.toggleServeOpen({serviceId: row.serviceId})
      if (code === 0) {
        row.validFlag = value
      } else {
        this.$message({
          type: 'error',
          message: msg
        })
      }
    },
    deleteServe (index) {
      let serviceId = this.tableData[index].serviceId
      let name = this.tableData[index].serviceName
      this.$confirm(`确定要删除服务[${name}]吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await serve.delServe({
          'serviceId': serviceId
        })
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '服务删除成功'
          })
          this.tableData.splice(index, 1)
        } else {
          this.$message({
            type: 'error',
            message: msg || '服务删除失败'
          })
        }
      })
    }
  }

}
</script>
<style scoped>
</style>
